import React from "react";
import { Modal, Button } from "react-bootstrap";
import "./Explore.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLocationDot, faBriefcase, faCalendarDays } from "@fortawesome/free-solid-svg-icons";


function ExploreModal({ show, job, onClose }) {
  if (!job) return null; // Prevent errors if job is null

  return (
    <Modal show={show} onHide={onClose} centered className="custom-modal" backdropClassName="custom-backdrop">
      <Modal.Header>
        <Modal.Title className="mb-2">
            {job.position}
        </Modal.Title>
        <div className="subTitle-modal">
        <p>
            <FontAwesomeIcon icon={faLocationDot} className="icon-modal"/>
            {job.location}
        </p>
        <p>
            <FontAwesomeIcon icon={faBriefcase} className="icon-modal"/>
            {job.mode}
        </p>
        <p>
            <FontAwesomeIcon icon={faCalendarDays} className="icon-modal"/>
            {job.time}
        </p>
        </div>
      </Modal.Header>
      <Modal.Body>
        <div className="jo-content">
            <h6 className="fw-bold">Job Debscription:</h6>

                {job.jobDescription.map((description, index) => (
                    <p key={index}>{description}</p>
                ))}
        </div>
        <div className="requirements-content">
            <h6 className="fw-bold">Experience Requirements:</h6>
            <ul>
                {job.requirements.map((requirement, index) => (
                    <li key={index}>{requirement}</li>
                ))}
            </ul>
        </div> 
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={() => window.open(job.link, '_blank')}>
          Apply Now
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default ExploreModal;